import React from "react";
import { Tooltip as ReactTooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";

const AppTooltip = ({ id, place = "top", style = {}, children, ...rest }) => {
  const defaultStyle = {
    backgroundColor: "#ffffff",
    color: "#212121",
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
    borderRadius: "6px",
    fontSize: "12px",
    padding: "6px 10px",
    zIndex: 9999,
    maxWidth: "220px",
    whiteSpace: "normal",
    wordBreak: "break-word",
    "--rt-opacity": 1,
  };

  return (
    <ReactTooltip
      id={id}
      place={place}
      delayShow={350}
      style={{ ...defaultStyle, ...style }}
      {...rest}
    >
      {children}
    </ReactTooltip>
  );
};

export default AppTooltip;
